import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import Jobs from './jobs';
import Decisions from './decisions';
import Team from './team';
import Followers from './followers';
import Blogs from './blogs';
import Repos from './repos';
import TechTalks from './tech-talks';
import TechStacks from './tech-stacks';
import StackApplications from './stack-applications';
import {PrivateModeContext} from '../../../../shared/enhancers/private-mode-enchancer';
import PrivateTeams from './pivate-teams';
import {STACK_APPLICATIONS} from '../../../../shared/constants/features';
import {featurePermissionCheck} from '../../../../shared/utils/feature-permission-check';
import {
  ORG_STRUCTURE_MODES,
  OrganizationContext
} from '../../../../shared/enhancers/organization-enhancer';

const Sections = ({company, isAdmin, isSiteAdmin, isPrivate}) => {
  const privateMode = useContext(PrivateModeContext);
  const stackApplicationsPermission = featurePermissionCheck(privateMode, STACK_APPLICATIONS);
  const {currentOrg, orgStructureMode} = useContext(OrganizationContext);

  return (
    <>
      {company.jobs.count > 0 && <Jobs companyId={company.id} count={company.jobs.count} />}
      {company.stackDecisions.count > 0 && (
        <Decisions
          companyId={company.id}
          count={company.stackDecisions.count}
          currentOrg={currentOrg}
        />
      )}
      {company.stacksList.count > 0 && (
        <TechStacks
          companyId={company.id}
          companySlug={company.slug}
          count={company.stacksList.count}
          companyGithubAppSettingsUrl={company.githubAppSettingsUrl}
          githubAppInstalled={company.githubAppInstalled}
          azureAppInstalled={company.azureAppInstalled}
          privateCompany={company.privateMode}
          currentOrg={currentOrg}
        />
      )}
      {company.stackApps.count > 0 && isPrivate && stackApplicationsPermission && (
        <StackApplications
          companyId={company.id}
          companySlug={company.slug}
          count={company.stackApps.count}
          currentOrg={currentOrg}
        />
      )}
      {company.privateTeams.count > 0 &&
        isPrivate &&
        orgStructureMode !== ORG_STRUCTURE_MODES.flexible && (
          <PrivateTeams
            companyId={company.id}
            count={company.privateTeams.count}
            isPrivate={isPrivate}
            isAdmin={isAdmin}
            isSiteAdmin={isSiteAdmin}
            companySlug={company.slug}
            currentOrg={currentOrg}
          />
        )}
      {company.blogPosts.count > 0 && (
        <Blogs companyId={company.id} count={company.blogPosts.count} />
      )}
      {company.githubRepos.count > 0 && !isPrivate && (
        <Repos companyId={company.id} count={company.githubRepos.count} />
      )}
      {company.socialPosts.count > 0 && (
        <TechTalks companyId={company.id} count={company.socialPosts.count} />
      )}
      {company.members.count > 0 &&
        (privateMode && !privateMode.loading) &&
        company.privateMode &&
        isPrivate && (
          <Team
            isAdmin={isAdmin}
            isSiteAdmin={isSiteAdmin}
            companyId={company.id}
            companySlug={company.slug}
            count={company.members.count}
            isPrivate={isPrivate}
            currentOrg={currentOrg}
          />
        )}
      {company.members.count > 0 && !company.privateMode && !isPrivate && (
        <Team
          isAdmin={isAdmin}
          isSiteAdmin={isSiteAdmin}
          companyId={company.id}
          companySlug={company.slug}
          count={company.members.count}
          isPrivate={isPrivate}
          currentOrg={currentOrg}
        />
      )}

      {company.followers.count > 0 && isPrivate && (
        <Followers companyId={company.id} count={company.followers.count} />
      )}
    </>
  );
};

Sections.propTypes = {
  company: PropTypes.object.isRequired,
  isAdmin: PropTypes.bool,
  isSiteAdmin: PropTypes.bool,
  isPrivate: PropTypes.bool
};
export default Sections;
